import logoSrc from "../../assets/logo.png";

/**
 * Zentrale Logo-Komponente ("Phantom of Hell" Club-Patch).
 *
 * Einziger Referenzpunkt für das Markenlogo im gesamten Frontend - ein
 * späterer Austausch betrifft ausschließlich die Datei
 * `frontend/src/assets/logo.png` (Seitenverhältnis ca. 900×1090, PNG mit
 * ECHTER Alpha-Transparenz rund um den Patch - kein Hintergrund mehr,
 * fügt sich daher nahtlos in jeden Untergrund ein).
 * Alle Verwendungsstellen (Login, Sidebar, MobileDrawer, Topbar, Footer,
 * Dashboard-Wasserzeichen) importieren ausschließlich diese Komponente,
 * niemals direkt die Bilddatei - so bleibt der Logo-Austausch an einer
 * einzigen Stelle zentral wartbar.
 *
 * `object-contain` + explizite Höhe/Breite über className verhindern jede
 * Verzerrung; das Seitenverhältnis bleibt auf allen Bildschirmgrößen erhalten.
 */
interface LogoProps {
  /** Tailwind-Klassen für Größe (z.B. "h-10 w-auto"). Steuert ausschließlich die Größe, niemals die Bildproportionen selbst. */
  className?: string;
  /** true für oberhalb-des-Falzes-Einsatz (Login) - lädt sofort statt lazy. */
  eager?: boolean;
  /** Zusätzliche Klassen für dezente Animation (z.B. Fade-in/Schweben auf der Login-Seite). */
  animated?: boolean;
}

export function Logo({ className = "h-10 w-auto", eager = false, animated = false }: LogoProps) {
  return (
    <img
      src={logoSrc}
      alt="Phantom of Hell LBV-System"
      className={`object-contain select-none ${animated ? "logo-animated" : ""} ${className}`}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      draggable={false}
    />
  );
}
